import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';


@Injectable({
  providedIn: 'root'
})
export class MessageService {

  loadingCtrlId: any;

  constructor(
    private message: NzMessageService,
    private translateService: TranslateService
  ) {
  }

  success(message: string, duration: number = 3000) {
    this.message.create('success', message, { nzDuration: duration });
  }

  error(message: string, duration: number = 3000) {
    this.message.create('error', message, { nzDuration: duration });
  }

  async saveSuccess() {

    var message = await this.translateService.get("Common.SavedSucessfully").toPromise();
    this.success(message);
  }

  updateSuccess() {
    this.success('修改成功');
  }

  async deleteSuccess() {
    var message = await this.translateService.get("Common.DeletedSuccessfully").toPromise();
    this.success(message);
  }

  showLoading(): void {
    if (!this.loadingCtrlId) {
      this.loadingCtrlId = this.message.loading(this.translateService.instant('Common.Loading'), { nzDuration: 0 }).messageId;
    }
  }

  hideLoading() {
    this.message.remove(this.loadingCtrlId);
    this.loadingCtrlId = null;
  }

  async exportSuccess() {
    const message = await this.translateService.get("Common.ExportSuccessfully").toPromise();
    this.success(message);
  }

  operateSuccess() {
    this.success('操作成功');
  }
}
